import { Action, Reducer } from 'redux';
import { REHYDRATE } from 'redux-persist';

import { REFERRER_RESET, SET_ATTRIBUTION, SET_HAS_PARTNER_REFERRER } from '../../actions/action-types';
import { ReferrerState } from '../../types/state/referrer';

type RehydrateAction = Action & {
  key: string;
  payload: Partial<ReferrerState>;
};

type ResetReferrerAction = Action;

type SetAttributionAction = Action & {
  attributionId: string | undefined;
};

type SetHasPartnerReferrerAction = Action & {
  hasPartnerReferrer: boolean;
};

type SetPartnerPropensityAction = Action & {
  partnerWithPropensity: string | null;
};

type ReferrerAction =
  | RehydrateAction
  | SetAttributionAction
  | SetHasPartnerReferrerAction
  | SetPartnerPropensityAction
  | ResetReferrerAction;

const initialState: ReferrerState = {};

const referrerReducer: Reducer<ReferrerState, ReferrerAction> = (
  state = initialState,
  action = {} as ReferrerAction,
) => {
  const reducers: Record<string, () => ReferrerState> = {
    [REFERRER_RESET]: () => initialState,
    [REHYDRATE]: () => {
      if ((action as RehydrateAction).key === 'referrer') {
        return {
          ...state,
          ...(action as RehydrateAction).payload,
        };
      }
      return state;
    },

    [SET_ATTRIBUTION]: () => ({
      ...state,
      attribution: (action as SetAttributionAction).attributionId,
    }),

    [SET_HAS_PARTNER_REFERRER]: () => ({
      ...state,
      hasPartnerReferrer: (action as SetHasPartnerReferrerAction).hasPartnerReferrer,
    }),
  };

  const reducer = reducers[action.type];
  return reducer ? reducer() : state;
};

export default referrerReducer;
